export function escapeChatHtml(text) {
    return String(text || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
}

function unescapeChatHtml(text) {
    return String(text || '')
        .replace(/&quot;/g, '"')
        .replace(/&gt;/g, '>')
        .replace(/&lt;/g, '<')
        .replace(/&amp;/g, '&')
}

function escapeAttr(text) {
    return String(text || '')
        .replace(/&/g, '&amp;')
        .replace(/"/g, '&quot;')
        .replace(/</g, '&lt;')
}

function isSafeHttpUrl(url) {
    try {
        const parsed = new URL(url)
        return parsed.protocol === 'http:' || parsed.protocol === 'https:'
    } catch {
        return false
    }
}

function linkifyMarkdown(html) {
    return html.replace(/\[([^\]]+)\]\s*\(([^)]+)\)/g, (match, label, rawUrl) => {
        const href = unescapeChatHtml(rawUrl).replace(/\s+/g, '')
        if (!isSafeHttpUrl(href)) {
            return match
        }

        return `<a href="${escapeAttr(href)}" target="_blank" rel="noopener noreferrer">${label}</a>`
    })
}

export function formatChatHtml(text) {
    return linkifyMarkdown(escapeChatHtml(text))
        .replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>')
        .replace(/\n/g, '<br>')
}
